export function hubIdOf(loc) {
  if (!loc) return '';
  return loc.id ?? loc.hub_id ?? loc.location_hub_id ?? '';
}

/** OWN destination hubs with more than one active agent — eligible for “assign ML to location”. */
export function ownHubsEligibleForMlLocationAssign(toLocationIds, locations, agents) {
  const toSet = new Set((toLocationIds || []).map(String));
  return (locations || []).filter((loc) => {
    const id = String(hubIdOf(loc) || '');
    if (!id || !toSet.has(id)) return false;
    if (String(loc.ownership_type || 'OWN').toUpperCase() !== 'OWN') return false;
    const n = (agents || []).filter((a) => String(a.location_hub_id) === id).length;
    return n > 1;
  });
}
